import React from 'react';
import { styled } from '@linaria/react';
import noop from 'lodash/noop';
const Flex = /*#__PURE__*/styled('ul')({
  name: "Flex",
  class: "fu09wn1",
  propsAsIs: false
});
export const TabsContext = React.createContext<Props>({
  value: '',
  onChange: noop
});
interface Props {
  value?: string;
  onChange: (value: string) => void;
}
export const Tabs: React.FC<Props> = ({
  value,
  onChange,
  children
}) => {
  return <TabsContext.Provider value={{
    value,
    onChange
  }}>
      <Flex>{children}</Flex>
    </TabsContext.Provider>;
};

require("./Tabs.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Tabs.tsx");